import { all, takeEvery, put, call } from "redux-saga/effects";
import AlertNotificationApiService from './AlertNotificationApiService'
import { GET_MY_ALERT_NOTIFICATION_DETAILS ,GET_DELETE_ALERT_NOTIFICATION_DETAILS, GET_DELETE_ALL_ALERTS, GET_DELETE_ALL_NOTIFICATIONS} from '../../Store/AlertNotification/AlertNotificationType'
import {SetDeleteAllAlerts, SetDeleteAllNotifications, SetMyAlertNotificationtDetails, SetIsAlertNotificationApiCalled, SetDeleteAlertNotificationdetails} from "Store/AlertNotification/AlertNotificationAction";
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { API_URL, apiMethod, apiType } from "utils";
import { IPayload } from "Model/IPayload";

function* getMyAlertNotificationDetailsSaga(req: any): any {
  yield put(SetIsAlertNotificationApiCalled(true))
  let payloadData : IPayload = {
    apiMethod: apiMethod.GET,
    apiType: apiType.Notification,
    endpoint: `notification/getUserAlertNotifications?userId=${req?.notificationdetails}`,
    payload: null
  }   
      
  try {
   //Get Notification in My notification
    const response = yield call(
    AlertNotificationApiService.post,
    API_URL.PostWebApp, payloadData
   );
  
    yield put(SetMyAlertNotificationtDetails(response));
     yield put(SetIsAlertNotificationApiCalled(false))

  } catch (error) {
    yield put(
      SetMyAlertNotificationtDetails({
        notificationCount: 0,
        notificationDetails: [],
        alertCount: 0,
        alertDetails: [],
      })
    );
    yield put(SetIsAlertNotificationApiCalled(false))
  }
}
function* deleteNotificationAlertSaga(req: any): any {
  let payloadData : IPayload = {
    apiType : apiType.Notification,
    endpoint : `notification/deleteAlertNotification?sentNotificationId=${req?.deletenotificationdetails.notificationId}&savedBy=${req?.deletenotificationdetails.userId}`,
    apiMethod : apiMethod.GET,
    payload : null
  }
  
  try {
    const response = yield call(
      AlertNotificationApiService.post,API_URL.PostWebApp,payloadData
      
    );
    yield put(SetDeleteAlertNotificationdetails(response));
  }catch (error) {
    yield put(SetDeleteAlertNotificationdetails(false));
  }
  
}
function* deleteAllNotificationsSaga(req: any): any {
  let payloadData : IPayload = {
    apiType : apiType.Notification,
    endpoint : `notification/notifications/clearall/${req?.deleteAllNotifications}`,
    apiMethod : apiMethod.GET,
    payload : null
  }
  
  try {
    yield put(globalLoaderText("Deleting All Notifications..."));
    const response = yield call(
      AlertNotificationApiService.post, API_URL.PostWebApp,payloadData
      
    );
    if(response){
    yield put(SetDeleteAllNotifications(response));
    yield put(globalLoaderText(""));
    }
  }catch (error) {
    yield put(SetDeleteAllNotifications(false));
    yield put(globalLoaderText(""));
  }
  
}
function* deleteAllAlertsSaga(req: any): any {
  let payloadData : IPayload = {
    apiType : apiType.Notification,
    endpoint : `notification/alerts/clearall/${req?.deleteAllAlerts}`,
    apiMethod : apiMethod.GET,
    payload : null
  }
    
  try {
    yield put(globalLoaderText("Deleting All Alerts..."));
    const response = yield call(
      AlertNotificationApiService.post,API_URL.PostWebApp,payloadData
      
    );
    if(response){
      yield put(globalLoaderText(""));
      yield put(SetDeleteAllAlerts(response));
    }
  }catch (error) {
    yield put(SetDeleteAllAlerts(false));
    yield put(globalLoaderText(""));
  }
  
}
function* watcherGetNotification() {
  yield takeEvery(GET_MY_ALERT_NOTIFICATION_DETAILS, getMyAlertNotificationDetailsSaga);
  yield takeEvery(GET_DELETE_ALERT_NOTIFICATION_DETAILS, deleteNotificationAlertSaga);
  yield takeEvery(GET_DELETE_ALL_NOTIFICATIONS, deleteAllNotificationsSaga);
  yield takeEvery(GET_DELETE_ALL_ALERTS, deleteAllAlertsSaga);
}

export default function* combinedSaga() {
  yield all([watcherGetNotification()]);
}